const parser = new DOMParser();

export function htmlToText(html: string) {
	if (!html) {
		return '';
	}
	const dom = parser.parseFromString(html, 'text/html');
	return dom.body.textContent.trim();
}
